/**
 * The kinds of normalization a free-text field can ask for.
 * Passed to `normalizeText` and to `showTextFieldModal`'s
 * `options.normalize`.
 */
const TextNormalization = {
    // Take the typed value exactly as-is.
    'None': 'none',

    // Every whitespace run (spaces, tabs, newlines) becomes a single
    // space, then both ends are trimmed. So
    //     "   Johnn\n\n\nyyy\n\nappleseed\t\t\t\n"
    // becomes
    //     "Johnn yyy appleseed"
    // Deliberately collapses runs rather than stripping whitespace
    // outright, so `John H` and `JohnH` stay two different values.
    'Whitespace': 'whitespace',
}
Object.freeze(TextNormalization)

/**
 * Collapses every whitespace run to a single space and trims both ends.
 * Non-strings pass through untouched.
 * @param {string} value
 * @return {string}
 */
function normalizeWhitespace(value) {
    if (typeof value !== 'string') {
        return value
    }
    return value.replace(/\s+/g, ' ').trim()
}

/**
 * Applies one of the `TextNormalization` kinds to a value.
 * An unknown kind is treated as `None` so a typo in a call site can never
 * silently mangle what someone typed.
 * @param {string} value
 * @param {string} kind one of `TextNormalization`
 * @return {string}
 */
function normalizeText(value, kind) {
    if (kind === TextNormalization.Whitespace) {
        return normalizeWhitespace(value)
    }
    return value
}

module.exports = {
    TextNormalization,
    normalizeWhitespace,
    normalizeText,
}
